import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { styleguide, colors } from "../../../../styleguide";
export var NotificationBadge = styled.div.withConfig({
  displayName: "Counter__NotificationBadge",
  componentId: "sc-ez8nq6-0"
})(["box-sizing:content-box;background-color:", ";border-radius:20px;font-size:10px;padding:2px;display:flex;flex-direction:column;line-height:1.6;height:15px;min-width:15px;text-align:center;border:1px solid ", ";color:", ";font-family:", ";text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"], colors.red500, colors.white100, colors.white100, styleguide.font.family.medium);
export var NotificationCounter = function NotificationCounter(_ref) {
  var notificationNumber = _ref.notificationNumber,
      className = _ref.className;

  if (notificationNumber > 0) {
    return /*#__PURE__*/React.createElement(NotificationBadge, {
      className: className
    }, Math.min(notificationNumber, 999));
  }

  return null;
};
NotificationCounter.propTypes = process.env.NODE_ENV !== "production" ? {
  notificationNumber: PropTypes.number,
  className: PropTypes.string
} : {};
export default NotificationCounter;
//# sourceMappingURL=Counter.js.map